export default class ComponenteAssinaturaOptions {
  constructor({
    ticketId = 0,
    componenteId = 0,
    mensagemDeAlerta = null,
    fetchSignature = false,
  } = {}) {
    this.ticketId = ticketId
    this.componenteId = componenteId
    this.mensagemDeAlerta = mensagemDeAlerta
    this.fetchSignature = fetchSignature
  }
}
